// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__2zKB5","main":"Sidebar_main__1qkKi","iconDiv":"Sidebar_iconDiv__ZbjYG","textDiv":"Sidebar_textDiv__39DvJ","logout":"Sidebar_logout__XVGRm"};